const OPTIONS = {
  method: fetchmethod => ({ method: fetchmethod }),
  headers: {},
  body: JSON.stringify({}),
};

export default OPTIONS;
